import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

function NotFound() {
  const intl = useIntl();

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <div className="text-center">
        <h1 className="display-1 fw-bold text-primary">404</h1>
        <h2 className="mb-3">{intl.formatMessage({ id: 'notFound.title' })}</h2>
        <p className="text-muted mb-4">{intl.formatMessage({ id: 'notFound.subtitle' })}</p>
        <Link to="/dashboard" className="btn btn-primary">
          {intl.formatMessage({ id: 'notFound.goHome' })}
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
